var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCameraWhiteGc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "9px",
    viewBox: "0 0 13 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCameraWhiteGC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chatrooms_Home--Copy",
    transform: "translate(-276.000000, -271.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(267.000000, 257.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7169942,14.2600651 C21.6541322,14.2366691 21.5936841,14.2249218 21.535599,14.2249218 C21.4049966,14.2249218 21.2962967,14.2695466 21.2091691,14.3585499 L18.2856054,17.1851814 L18.2856054,16.0250351 C18.2856054,15.4671512 18.0812659,14.9902667 17.672587,14.5941354 C17.2638826,14.1980533 16.7719129,14 16.1962711,14 L11.0892326,14 C10.5137688,14 10.0216465,14.1980533 9.61291678,14.5941354 C9.20433947,14.9902667 9,15.4671512 9,16.0250351 L9,20.9750388 C9,21.5328734 9.20433947,22.0097333 9.61294219,22.40584 C10.021672,22.8019467 10.5137942,23 11.089258,23 L16.1963219,23 C16.7719383,23 17.2639334,22.8019467 17.6726378,22.40584 C18.0813167,22.0097333 18.2856562,21.5328981 18.2856562,20.9750388 L18.2856562,19.8077751 L21.20922,22.6414254 C21.2963475,22.7304041 21.4050474,22.7750043 21.5356499,22.7750043 C21.5937349,22.7750043 21.654183,22.7632817 21.717045,22.7399349 C21.9057579,22.6602161 22,22.5219827 22,22.3251114 L22,14.6750117 C21.9999238,14.478042 21.9056817,14.3397839 21.7169942,14.2600651 Z",
    id: "icCameraWhiteGC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraWhiteGc);
export default __webpack_public_path__ + "static/media/icCameraWhiteGC.cd67dc1b28a4a565c864d6354d4e02ab.svg";
export { ForwardRef as ReactComponent };